module.exports = __webpack_public_path__ + "img/5.f18144d2.jpg";